import React, { useEffect } from 'react';
import NewConferenceAuth from './conference-auth-new';
// defined in the api, in v4/access/auth.service.ts startDeviceAuth()
//const expirationInMs = 1000 * 60 * 60;
// 15 seconds before the code expires, refresh the code
//const codeIsValidFor = expirationInMs - 1000 * 15;

declare global {
  interface Window {
    synergysky?: SynergySky;
  }
}

interface SynergySky {
  startSession: (version: string, appId: string) => Promise<void>;
}

const ConferenceAuth: React.FC = () => {
  useEffect(() => {
    const loadSynergySky = async () => {
      const isSynergySkySession = (window as Window).synergysky;
      if (isSynergySkySession) {
        await (window as Window).synergysky?.startSession('1.0', 'greenroom-qa');
      }
    };

    loadSynergySky();
  }, []);

  return <NewConferenceAuth />;
};

export default ConferenceAuth;
